const simulatorRunner = {
    bindings: {
        simulationData: '<',
        simulationOptions: '<'
    },
    templateUrl: '/modules/pis-tool/simulator/simulator-runner/simulator-runner.html',
    controller: 'SimulatorRunnerController',
};

angular
    .module('pis-tool.module')
    .component('simulatorRunner', simulatorRunner)
    .config(function ($stateProvider) {
        $stateProvider.state('pis.workspaces.simulator.runner', {
            url: '/runner',
            views: {
                'simulatorView@pis.workspaces.simulator': 'simulatorRunner',
            },
        });
    });
